import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=354f1c9f&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=354f1c9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354f1c9f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('354f1c9f')) {
      api.createRecord('354f1c9f', component.options)
    } else {
      api.reload('354f1c9f', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=354f1c9f&scoped=true&", function () {
      api.rerender('354f1c9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ABgtia4CLZdL/JS/teamMember.vue"
export default component.exports